import { component as defineComponent } from 'flightjs';
import withAsyncMenu from './mixins/async-menu';

export default defineComponent(withAsyncMenu);



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/lib/ui/messages-menu.js